import { css } from 'styled-components';
import { CFBaseSegmentControlHelpers } from './styles';
import { CFTokens } from '../../tokens';
export const CFBaseSegmentControlStyles = {
    Label: css `
    ${CFBaseSegmentControlHelpers.labelStyles};
  `,
    Root: css `
    box-sizing: border-box;
    padding: ${CFBaseSegmentControlHelpers.rootPadding};
    height: ${CFBaseSegmentControlHelpers.rootHeight}px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: ${CFTokens.SPACER.B}px;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    background-color: ${CFBaseSegmentControlHelpers.rootBackground};
    cursor: pointer;
  `,
    RootWebInteractions: css `
    ${CFBaseSegmentControlHelpers.rootWebInteractions};
  `,
};
